import React from "react"

import Spacer from "@p-ban/common/src/components/layout/Spacer"

import OneClickErrorText from "../OneClickErrorText"

type Props = {
  error: string | undefined
  children?: React.ReactNode
}

const OneClickFieldMessages = ({ error, children }: Props) => {
  const shouldRender = !!(error || React.Children.toArray(children).length)

  if (shouldRender) {
    return (
      <>
        <Spacer size={6} />
        {children}
        {error && <OneClickErrorText>{error}</OneClickErrorText>}
      </>
    )
  }

  return null
}

export default OneClickFieldMessages
